import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from 'reactstrap';
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';
import Translate from '../Translate';

export const DefaultAlertModal = ({
  isOpen,
  toggle,
  centered,
  header,
  withHeader,
  body,
  cancelBtn,
  validateBtn,
  handleCancel,
  handleValidate,
  disable,
  size,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered={centered} size={size}>
      {withHeader && (
        <ModalHeader className="model-title">
          <Translate code={header} />
        </ModalHeader>
      )}
      <ModalBody>{body}</ModalBody>
      <ModalFooter className="justify-content-center pt-1">
        <Row className={isMobile && `d-flex flex-wrap-reverse`}>
          <Col className={isMobile ? `mt-2` : `mb-2`}>
            {cancelBtn && (
              <button className="btn btn-block btn-3" onClick={handleCancel} type="button">
                <Translate code={cancelBtn} />
              </button>
            )}
          </Col>
          <Col>
            {validateBtn && (
              <button
                className="btn btn-block btn-1"
                data-test={`${validateBtn}-btn`}
                onClick={handleValidate}
                type="button"
                disabled={disable}
              >
                <Translate code={validateBtn} />
              </button>
            )}
          </Col>
        </Row>
      </ModalFooter>
    </Modal>
  );
};

DefaultAlertModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleValidate: PropTypes.func,
  isOpen: PropTypes.bool.isRequired,
  withHeader: PropTypes.bool,
  disable: PropTypes.bool.isRequired,
  header: PropTypes.string,
  cancelBtn: PropTypes.string,
  validateBtn: PropTypes.string,
  centered: PropTypes.bool.isRequired,
  size: PropTypes.string.isRequired,
  body: PropTypes.oneOfType([PropTypes.shape(), PropTypes.string]).isRequired,
};

DefaultAlertModal.defaultProps = {
  handleValidate: undefined,
  withHeader: undefined,
  header: undefined,
  cancelBtn: undefined,
  validateBtn: undefined,
};
